import { createEffect } from 'effector';
import { jenksBuckets } from 'geobuckets/dist/src/index.js';
import { api } from '../../api/axiosinstance.js';
import { filterBuckets } from '../../utils/gradient-utils.js';

export const getABCountriesFx = createEffect().use(async () => {
  return (await api().get(`trademap/countries`)).data;
});

export const getABHSCodesFx = createEffect().use(async () => {
  return (await api().get(`trademap/hscodes`)).data;
});

export const getABCountriesHSDataFx = createEffect().use(async (hscode) => {
  return (await api().get(`trademap/${hscode}`)).data;
});

export const getABBucketsFx = createEffect().use(async (payload) => {
  const { polygons, activeLayer } = payload;
  const data = polygons.map((item) => {
    if (
      item.properties[activeLayer] !== null &&
      item.properties[activeLayer] !== undefined
    ) {
      return item.properties[activeLayer];
    }
    return null;
  });

  let buckets = await jenksBuckets(data, 9);
  buckets = buckets.map((item) => Math.floor(item));
  buckets[buckets.length - 1] = buckets[buckets.length - 1] + 1;

  return filterBuckets(data, buckets);
});
